import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import photo from "../../assets/photo.png";

// ..
AOS.init();

export default function About() {
  return (
    <div className="w-full bg-white pb-8 " id="about">
      <div className="mx-5 lg:mx-20 h-full">
        <div className="pt-5 text-xl text-center" data-aos="zoom-in">
          <h1 className="font-Poppins font-medium text-slate-400">ABOUT ME</h1>
        </div>
        <div className="flex flex-col lg:flex-row items-center mt-5">
          <div className=" w-4/5 lg:w-1/2">
            <div
              className="w-full flex justify-center items-center "
              data-aos="fade-right"
            >
              <div className="rounded-full border-2 border-slate-400 ">
                <img
                  src={photo}
                  className="rounded-full h-60 lg:h-80 m-2"
                  alt="myPicture"
                />
              </div>
            </div>
          </div>
          <div className="w-4/5 lg:w-1/2">
            <h1
              data-aos="zoom-in"
              className="text-lg lg:text-xl font-Poppins font-bold mb-2 lg:mb-4 lg:text-start text-center mt-4 md:mt-4 sm:mt-4 lg:mt-0"
            >
              Who{" "}
              <span className="text-[#3aa1ff] underline underline-offset-[5px]">
                i am
              </span>{" "}
              ?
            </h1>
            <div
              className="w-full h-full flex justify-center items-center"
              data-aos="fade-left"
            >
              <p className="text-md font-Nanum font-medium text-center lg:text-start mt-4 lg:mt-0">
                Hi, i'm{" "}
                <span className="text-[#3aa1ff] font-bold">
                  Frantzley ADOLPHE
                </span>
                {" "}with four (4) years experiences and i'm passionate about
                everything that has to do with digital design and art direction,
                i've a serious passion for UI effects, animations and creating,
                dynamic user experiences and coding. I enjoy working with
                agencies and enthusiastic people who want to solve problems
                through beautiful design, website, mobile application and
                photographies.
              </p>
            </div>
            <div
              className="flex w-full flex-row items-center"
              data-aos="zoom-in"
            >
              <div className="flex flex-col w-1/2 pt-4 md:text-center text-center lg:text-start">
                <h1 className="font-Poppins font-bold text-lg">8 +</h1>
                <p className=" text-xs font-Poppins">Projects completed</p>
              </div>
              <div className="flex flex-col w-1/2 pt-4 md:text-center text-center lg:text-start">
                <h1 className="font-Poppins font-bold text-lg">3</h1>
                <p className=" text-xs font-Poppins">Entreprises corvered</p>
              </div>
            </div>
            <div
              className="flex justify-center items-center lg:justify-start hover:cursor-auto "
              data-aos="zoom-in"
            >
              <a href="#contact" className="text-center text-[#3aa1ff] border-2 border-[#3aa1ff] mt-6 p-2 w-40 rounded-full hover:bg-[#131315] hover:text-[#f1edfd]">
                Hire me
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
